import React, { useState, useEffect } from 'react'
import {
    Row,
    Col,
    Card,
    CardBody,
    CardFooter,
    Button,
    Spinner,
    Modal,
    ModalHeader,
    ModalBody,
    Progress,
    Badge,
    FormGroup,
    Label,
    Input,
    CardTitle,
    CardText,

} from 'reactstrap'

import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';

import { Link, useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'

import LiveSettings from '../common/settings'
import MasterPassword from '../common/settings/master_password'
import InvestorPassword from '../common/settings/investor_password'
import ChangeLeverage from '../common/settings/leverage'
import Deposit from '../common/settings/deposit'
// import RedeemBonus from '../common/settings/redeem_bonus'

import { StyledRow, ResponsiveLiveDiv } from '../common/components.style'

import AccountService from '../../network/services/account'
import WalletService from '../../network/services/wallet'
import { useTranslation } from 'react-i18next'
import moment from 'moment'

// import RedeemIcon from './redeemIcon.svg'
import { Steps, Hints } from 'intro.js-react'

import GoldenClude from './Premium-01.png'
import DiamondClub from './Premium-02.png'
import VVIP from './Premium-03.png'

import PartibanPremiumPackage from './PartibanPremiumPack/packageInfo'
import SweetAlert from 'sweetalert2'

import { useForm } from 'react-hook-form'

import styled from 'styled-components'

import './index.scss'

import ScrollDownIcon from './down-arrow.png'

import 'react-accessible-accordion/dist/fancy-example.css';

import GreenChecked from './checked.png'

function VePackageModal({ account, accountDetails, partibanPremiumUpgradeModal, setPartibanPremiumUpgradeModal, upgradePartibanPremiumModalToggle }) {


    const { t } = useTranslation()

    const [personalDetailsModal, setPersonalDetailsModal] = useState(false)
    const [packageSelect, setPackageSelect] = useState('')
    const [applicateName, setApplicateName] = useState('')
    const [identity, setIdentity] = useState('')
    const [isBusy, setIsBusy] = useState(false)
    const userProfile = useSelector((state) => state.user.profile)

    const { register, handleSubmit, errors, formState } = useForm()

    const personalDetailsModalToggle = () => {
        setPersonalDetailsModal(!personalDetailsModal)
    }

    const [selectedPackage, setSelectedPackage] = useState(2)

    const handlePackageApplication = () => {

        setIsBusy(true)
        SweetAlert.fire({
            title: 'Are you sure you want to upgrade package?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t('financial.confirm'),
            cancelButtonText: t('financial.cancel'),
            reverseButtons: true
        }).then(async (result) => {
            setIsBusy(false)
            if (result.value) {
                try {

                    let result = await AccountService.upgradePackage(accountDetails.id, {
                        package_id: packageSelect,
                        applicant_name: applicateName,
                        identification_number: identity
                    })

                    if (result?.package_application?.id) {
                        SweetAlert.fire({
                            title: 'Applied Package Successfully',
                            icon: 'success'
                        }).then(() => {
                            setIsBusy(false)
                            setPartibanPremiumUpgradeModal(!partibanPremiumUpgradeModal)
                            window.location.reload()
                        })
                    }

                } catch (error) {
                    // SweetAlert.fire({
                    //   title: error.message,
                    //   icon: 'error'
                    // })
                    setIsBusy(false)
                    const errorCode = error.code
                    const errorTranslate = error.translate_params
                    SweetAlert.fire({
                        title: t(errorCode, errorTranslate),
                        icon: 'error'
                    }).then(() => {
                        window.location.href = '/financial'
                    })
                }
            }
        })
    }

    const faqItems = [

        {
            heading: t('live.WhatBenefitsCanIget'),
            content: ''
        },
        {
            heading: 'Can I upgrade my First Step Package Account to Premium Package Account in the future?',
            content: t('live.YesIfYouDepositUSD')
        },
        {
            heading: 'If my existing account is a Partiban Premium Package Account, can I use to upgrade or downgrade this account to another Premium Package?',
            content: t('live.NoInTheFuture')
        },
        {
            heading: 'Is it possible to review Partiban 1000 Premium / Partiban 5000 Premium / Partiban 10000 Premium courses?',
            content: t('live.AbsolutelyAllOfOur')
        }
    ]

    return (
        userProfile.hasOwnProperty('id') ?
            <Modal
                id="upgrade-live-modal"
                isOpen={account.id === accountDetails?.id && partibanPremiumUpgradeModal}
                toggle={upgradePartibanPremiumModalToggle}
                backdrop='static'

            >
                <ModalHeader toggle={upgradePartibanPremiumModalToggle} centered className='modalHeader-Package'>

                </ModalHeader>
                <ModalBody>
                    {/* Control CSS display property  */}
                    <Row style={{ justifyContent: 'center', paddingBottom: '20px' }}>
                        <h2 style={{ color: 'white', fontWeight: '300' }}>
                            Partiban Premium Package
                        </h2>
                    </Row>
                    <div
                        className="d-block d-sm-block d-md-flex d-lg-flex d-xl-flex"
                        style={{ justifyContent: 'space-between', marginTop: '20px' }}
                    >
                        <Col lg='1'></Col>
                        <Col lg='3'>

                            <Card
                                style={{
                                    boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)',
                                    borderRadius: '5px',
                                    textAlign: 'center',
                                    paddingBottom: '65px',
                                    
                                }}
                                onClick={() => {
                                    setSelectedPackage(13)
                                }}
                                className='premiumPackageEnglishCard responsiveCardPartibanPackagePack'
                            >

                                <div className='mt-3'>

                                    <h3>Stop Loss Hunting 1000</h3>
                                    <h6>Min Deposit $1,000</h6>
                                </div>

                                <img
                                    style={{
                                        width: '100%',
                                        margin: '0 auto'
                                    }}
                                    src='https://th-kyc-backup.s3.ap-southeast-1.amazonaws.com/assets/Pricing+table-04.png'
                                    alt="SLH1000"
                                />

                                <div
                                    style={{
                                        padding: '1rem 0',
                                        borderTopLeftRadius: '5px',
                                        borderTopRightRadius: '5px'
                                    }}
                                >

                                    <Button
                                        style={{
                                            width: '75%',
                                            margin: '10px auto 15px auto',

                                        }}
                                        className='packageButton'
                                        onClick={() => {
                                            // handlePackageApplication(4)
                                            setPackageSelect(13)
                                            personalDetailsModalToggle(account)
                                        }}
                                    >
                                        Upgrade To Stop Loss Hunting 1000
                                    </Button>

                                    <div style={{ display: 'flex' }}>
                                        <div style={{ margin: '0 auto' }}>
                                            {PartibanPremiumPackage?.stopLostHunting1000?.benefits?.map((benefit, index) => {
                                                return (
                                                    <div style={{ display: 'flex' }} key={index}>
                                                        <div style={{ marginRight: '10px' }}>
                                                            <img src={GreenChecked} style={{ width: '16px' }} alt='greenChecked' />
                                                        </div>
                                                        <p style={{ marginBottom: "10px", fontSize: '14px' }}>
                                                            {t(benefit?.name)}
                                                        </p>
                                                    </div>
                                                )
                                            })}

                                        </div>
                                    </div>
                                </div>

                            </Card>




                        </Col>

                        <Col lg='3'>

                            <Card
                                style={{
                                    boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)',
                                    borderRadius: '5px',
                                    textAlign: 'center',
                                    paddingBottom: '30px',


                                }}
                                onClick={() => {
                                    setSelectedPackage(14)
                                }}
                                className='premiumPackageEnglishCard responsiveCardPartibanPackagePack'
                            >

                                <div className='mt-3'>

                                    <h3>Stop Loss Hunting 5000</h3>
                                    <h6>Min Deposit $5,000</h6>
                                </div>

                                <img
                                    style={{
                                        width: '100%',
                                        margin: '0 auto'
                                    }}
                                    src='https://th-kyc-backup.s3.ap-southeast-1.amazonaws.com/assets/Pricing+table-05.png'
                                    alt="SLH1000"
                                />
                                <div
                                    style={{
                                        padding: '1rem 0',
                                        borderTopLeftRadius: '5px',
                                        borderTopRightRadius: '5px'
                                    }}
                                >

                                    <Button
                                        style={{
                                            width: '75%',
                                            margin: '10px auto 15px auto',

                                        }}
                                        className='packageButton'
                                        onClick={() => {
                                            // handlePackageApplication(5)
                                            setPackageSelect(14)
                                            personalDetailsModalToggle(account)
                                        }}
                                    >
                                        Upgrade To Stop Loss Hunting 5000
                                    </Button>

                                    <div style={{ display: 'flex' }}>
                                        <div style={{ margin: '0 auto' }}>
                                            <p style={{ marginBottom: "10px", fontSize: '16px' }}>
                                                Everything in SLH 1000, plus:
                                            </p>
                                            {PartibanPremiumPackage?.stopLostHunting5000?.benefits?.map((benefit, index) => {
                                                return (
                                                    <div style={{ display: 'flex' }} key={index}>
                                                        <div style={{ marginRight: '10px' }}>
                                                            <img src={GreenChecked} style={{ width: '16px' }} alt='greenChecked' />
                                                        </div>
                                                        <p style={{ marginBottom: "10px", fontSize: '14px' }}>
                                                            {t(benefit?.name)}
                                                        </p>
                                                    </div>
                                                )
                                            })}

                                        </div>
                                    </div>
                                </div>
                            </Card>

                        </Col>

                        <Col lg='3'>

                            <Card
                                style={{
                                    boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)',
                                    borderRadius: '5px',
                                    textAlign: 'center',

                                }}
                                onClick={() => {
                                    setSelectedPackage(15)
                                }}
                                className='premiumPackageEnglishCard responsiveCardPartibanPackagePack'
                            >

                                <div className='mt-3'>

                                    <h3>Personal Coaching 10000</h3>
                                    <h6>Min Deposit $10,000</h6>
                                </div>

                                <img
                                    style={{
                                        width: '100%',
                                        margin: '0 auto'
                                    }}
                                    src='https://th-kyc-backup.s3.ap-southeast-1.amazonaws.com/assets/Pricing+table-06.png'
                                    alt="SLH1000"
                                />
                                <div
                                    style={{
                                        padding: '1rem 0',
                                        borderTopLeftRadius: '5px',
                                        borderTopRightRadius: '5px'
                                    }}
                                >
                                    <Button
                                        style={{
                                            width: '75%',
                                            margin: '10px auto 15px auto',

                                        }}
                                        className='packageButton'
                                        onClick={() => {
                                            // handlePackageApplication(6)
                                            setPackageSelect(15)
                                            personalDetailsModalToggle(account)
                                        }}
                                    >
                                        Upgrade To Personal Coaching 1000
                                    </Button>

                                    <div style={{ display: 'flex' }}>
                                        <div style={{ margin: '0 auto' }}>
                                            <p style={{ marginBottom: "10px", fontSize: '16px' }}>
                                                Everything in SLH 5000, plus:
                                            </p>
                                            {PartibanPremiumPackage?.personalCoaching10000?.benefits?.map((benefit, index) => {
                                                return (
                                                    <div style={{ display: 'flex' }} key={index}>
                                                        <div style={{ marginRight: '10px' }}>
                                                            <img src={GreenChecked} style={{ width: '16px' }} alt='greenChecked' />
                                                        </div>
                                                        <p style={{ marginBottom: "10px", fontSize: '14px' }}>
                                                            {t(benefit?.name)}
                                                        </p>
                                                    </div>
                                                )
                                            })}

                                        </div>
                                    </div>
                                </div>

                            </Card>


                        </Col>

                        <Col lg='1'></Col>
                    </div>

                    <Row style={{ justifyContent: 'center', marginTop: '25px', marginBottom: '25px', flexDirection: 'column', alignItems: 'center' }}>
                        <p style={{ marginBottom: '10px', color: 'white' }}>{t('live.ScrollFor')}</p>
                        <img src={ScrollDownIcon} alt='scroll down icon' style={{ width: '30px' }} />
                    </Row>

                    <Row style={{ justifyContent: 'center', backgroundColor: '#F5F7FA', padding: '2rem 0rem' }}>
                        <Col lg='8'>
                            <h5 style={{ textAlign: 'center', marginBottom: '25px' }}>{t('live.FrequentlyAskedQuestions')}</h5>

                            <Accordion allowZeroExpanded allowMultipleExpanded>
                                {faqItems.map((item, index) => (
                                    <AccordionItem key={index}  >
                                        <AccordionItemHeading>
                                            <AccordionItemButton style={{ backgroundColor: '#FFF' }}>
                                                {item.heading}
                                            </AccordionItemButton>

                                        </AccordionItemHeading>
                                        <AccordionItemPanel>
                                            {item.content}
                                            {item.heading === t('live.WhatBenefitsCanIget') &&
                                                <a
                                                    href={sessionStorage.getItem('language') === 'en' ? 'https://th-kyc-backup.s3.ap-southeast-1.amazonaws.com/assets/partiban/Premium+Pack+Comparison-01.jpg' : 'https://th-kyc-backup.s3.ap-southeast-1.amazonaws.com/assets/partiban/Premium+Pack+Comparison-01.jpg'}
                                                    target='_blank'
                                                >
                                                    {t('live.ClickForMoreDetails')}
                                                </a>
                                            }
                                        </AccordionItemPanel>

                                    </AccordionItem>
                                ))}
                            </Accordion>

                        </Col>
                    </Row>

                    {/* Modal for personal details  */}
                    <Modal
                        // id="upgrade-live-modal"
                        isOpen={account.id === accountDetails?.id && personalDetailsModal}
                        toggle={personalDetailsModalToggle}
                        centered
                    >
                        <ModalHeader toggle={personalDetailsModalToggle} centered>
                            {t("live.FillInYourDetails")}
                        </ModalHeader>
                        <ModalBody>
                            <FormGroup>
                                <Label className="col-form-label pt-0">
                                    {t("live.ApplicantName")}
                                    <span style={{ color: 'red' }}>*</span>
                                    <br />
                                    <span style={{ fontSize: '12px' }}>{t("live.EnterYourNameAccording")}</span>
                                </Label>
                                <Input
                                    className="form-control"
                                    type="text"
                                    name="identification_number"
                                    innerRef={register({ required: true })}
                                    defaultValue=""
                                    onChange={(e) => { setApplicateName(e.target.value) }}
                                    placeholder="e.g. JohnSon"
                                >
                                </Input>
                                <span style={{ color: 'red' }}>{errors.identity && t("user.IdentityIsRequired")}</span>
                            </FormGroup>

                            <FormGroup>
                                <Label className="col-form-label pt-0">
                                    {t("user.IdentityCardPassportNumber")}
                                    <span style={{ color: 'red' }}>*</span>
                                </Label>
                                <Input
                                    className="form-control"
                                    type="text"
                                    name="identification_number"
                                    innerRef={register({ required: true })}
                                    defaultValue=""
                                    onChange={(e) => { setIdentity(e.target.value) }}
                                    placeholder="e.g. 901111012345"
                                >
                                </Input>
                                <span style={{ color: 'red' }}>{errors.identity && t("user.IdentityIsRequired")}</span>
                            </FormGroup>

                            <p style={{ color: 'red' }}>
                                {packageSelect === 13 && t("live.Reminder300")}
                                {packageSelect === 14 && t("live.Reminder1500")}
                                {packageSelect === 15 && t("live.Reminder3000")}
                            </p>

                            <a href='https://th-kyc-backup.s3.amazonaws.com/3d973b32-2f35-4315-b662-525144c08867.pdf' style={{ textDecoration: 'underline' }} target="_blank">
                                {t("live.ReadTermsConditions")}
                            </a>
                            <p>
                                {t("live.ThePurposeOfThisAction")}
                            </p>

                            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <Button onClick={() => handlePackageApplication()} disabled={applicateName === '' || identity === '' || isBusy} color='primary' style={{ float: 'right' }}>{t('demo.submit')}</Button>
                                {isBusy && <Spinner color='warning' />}

                            </div>
                        </ModalBody>
                    </ Modal>

                </ModalBody>
            </Modal>
            :
            // Person who not fill in personal details
            <Modal

                isOpen={account.id === accountDetails?.id && partibanPremiumUpgradeModal}
                toggle={upgradePartibanPremiumModalToggle}
                centered
            >
                <ModalHeader toggle={upgradePartibanPremiumModalToggle} centered>
                    Premium Package Upgrade
        </ModalHeader>
                <ModalBody>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <p style={{ marginBottom: '0' }}>
                            Fill In Personal Details First
              </p>
                        <Link to='/account#details'>
                            <Button>Fill In</Button>
                        </Link>
                    </div>
                </ModalBody>
            </ Modal>

    )
}

export default VePackageModal
